import {
  getFirestore,
  collection,
  addDoc,
  Timestamp,
} from "firebase/firestore";
import sendErrorDiscord from "./sendErrorDiscord.js"; // Assuming a custom log function similar to FlutterFlow
import { useState } from "react";
import { getDoc, doc } from "firebase/firestore";
import { db, dbCentral } from "../config/FirebaseConfig.js";

const addLogDocument = async (
  url,
  prefix = "https://api.logement.hexagone.expert/",
  user_id,
  org_id,
  status,
  folderid,
  docid,
  request,
  response,
  type = "POST",
  delay = 0
) => {
  let start = new Date();

  let email = "";
  if (org_id) {
    const orgRef = doc(dbCentral, "org", org_id);

    const orgSnapshot = await getDoc(orgRef);
    email = orgSnapshot.get("email");
  }

  // Create the log document object
  const logDocument = {
    url: url,
    user_id: user_id ? user_id : "",
    org_id: org_id ? org_id : "",
    type: type,
    email: email,
    status: status,
    date: Timestamp.now(), // Firestore timestamp
    folderid: folderid || "",
    docid: docid || "",
    request: request || "",
    response: response || "",
    resolved: false, // Default resolved state
    delay: delay,
  };

  try {
    // Send error to Discord if status is not 200

    if (
      status.toString() !== "200" &&
      prefix === "https://api.logement.hexagone.expert/"
    ) {
      await sendErrorDiscord(
        `Hexagone Logement ERROR ${status} on endpoint: ${url}, response: ${
          response || ""
        }`,
        prefix
      );
      // Assuming you have an app state management system
      // FFAppState().error = true; can be translated to your React state management system
    }

    // Add the log document to the Firestore collection 'log'
    await addDoc(collection(db, "log"), logDocument);
    let end = new Date();
    let elapsed = end - start;
    return "Log document added successfully";
  } catch (error) {
    console.error("Error adding log document:", error);
    return `Error adding log document: ${error.message}`;
  }
};

export default addLogDocument;
